<template>
  <div
    v-bind="$attrs"
    class="mx-auto w-full max-w-screen-2xl px-5 py-4 md:px-8 md:py-8 xl:px-20 2xl:px-40"
  >
    <slot />
  </div>
</template>
